<div class="InfoTipButton">
  <app-svg-renderer
    [svg]="'Yellow Plane'"
    (click)="onInfoImageClick()"></app-svg-renderer>
</div>
